<template>
    <img class="spinner-img" v-bind="$attrs" src="images/ajax-loader.gif" />
</template>

<script>
export default {
    name: 'spinner',
};
</script>
